// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root___7wbm","label":"Section_label__3FBC7","contentWrap":"Section_contentWrap__2ukau","footer":"Section_footer__2dtQo","footerInner":"Section_footerInner__2An25"};